import { useEffect } from "react";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const TopLeftSVG = () => {


  useEffect(() => {
    let proxy = { skew: 0 },
      skewSetter = gsap.quickSetter(
        document.querySelectorAll(".top-left-svg"),
        "skewY",
        "deg"
      ), // fast
      clamp = gsap.utils.clamp(-50, 50); // don't let the skew go beyond 20 degrees.

    ScrollTrigger.create({
      onUpdate: (self) => {
        let skew = clamp(self.getVelocity() / -300);
        // only do something if the skew is MORE severe. Remember, we're always tweening back to 0, so if the user slows their scrolling quickly, it's more natural to just let the tween handle that smoothly rather than jumping to the smaller skew.
        if (Math.abs(skew) > Math.abs(proxy.skew)) {
          proxy.skew = skew;
          gsap.to(proxy, {
            skew: 0,
            duration: 0.8,
            ease: "power3",
            overwrite: true,
            onUpdate: () => skewSetter(proxy.skew),
          });
        }
      },
    });

    // make the right edge "stick" to the scroll bar. force3D: true improves performance
    gsap.set(document.querySelectorAll(".top-left-svg"), { transformOrigin: "right center", force3D: true });

  }, []);

  return (
    <svg
      className="top-left-svg"
      xmlns="http://www.w3.org/2000/svg"
      width="868"
      height="868"
      viewBox="0 0 868 868"
    >
     <g
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeWidth="1"
        opacity="0.276"
      >
        <g
          fillRule="nonzero"
          stroke="#fff"
          strokeWidth="0.4"
          transform="translate(1 -786)"
        >
          <g transform="translate(0 787)">
            <path d="M866 433L866 433"></path>
            <path d="M862 495L849 311"></path>
            <path d="M848 555L797 199"></path>
            <path d="M827 613L717 106"></path>
            <path d="M797 667L613 39"></path>
            <path d="M760 716L494 4"></path>
            <path d="M716 760L371 4"></path>
            <path d="M667 797L253 39"></path>
            <path d="M613 827L150 106"></path>
            <path d="M555 849L69 199"></path>
            <path d="M495 862L18 311"></path>
            <path d="M433 866L0 433"></path>
            <path d="M371 862L17 555"></path>
            <path d="M311 848L69 667"></path>
            <path d="M149 760L371 861"></path>
            <path d="M106 717L495 862"></path>
            <path d="M69 667L613 827"></path>
            <path d="M39 613L716 760"></path>
            <path d="M17 555L797 667"></path>
            <path d="M4 495L848 555"></path>
            <path d="M0 433L866 433"></path>
            <path d="M4 371L848 311"></path>
            <path d="M17 311L797 199"></path>
            <path d="M39 253L716 106"></path>
            <path d="M69 199L613 39"></path>
            <path d="M106 149L495 4"></path>
            <path d="M149 106L371 5"></path>
            <path d="M311 18L69 199"></path>
            <path d="M371 4L17 311"></path>
            <path d="M433 0L0 433"></path>
            <path d="M495 4L18 555"></path>
            <path d="M555 17L69 667"></path>
            <path d="M613 39L150 760"></path>
            <path d="M667 69L253 827"></path>
            <path d="M716 106L371 862"></path>
            <path d="M760 150L494 862"></path>
            <path d="M797 199L613 827"></path>
            <path d="M827 253L717 760"></path>
            <path d="M848 311L797 667"></path>
            <path d="M862 371L849 555"></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default TopLeftSVG;
